import Rest from "../../src/core/rest";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getReduxActionErrorMessage, isReduxThunkPendingAction, isReduxThunkRejectedAction } from '../core/utils';
import ErrorException from "src/components/ErrorException";
import { ApiGatewayUrl } from "../../src/appsettings";
import { STATUS_TYPES } from '../core/constants';

const SLICE_NAME = "superAdmin";

export const filterSuperAdmins = createAsyncThunk(
  "superAdmin/filterSuperAdmins",
  async (info) => {
    try {
      const response = await Rest.get(ApiGatewayUrl + "/superadmin/filter?page=" + info.page + "&rows_per_page=" + info.rows_per_page + "&filter_text=" + info.filter_text);
      return response.data;
    }
    catch (ex) {
      ErrorException(ex.response);
    }
  }
)
export const createUsers = createAsyncThunk(
  "superAdmin/createUsers",
  async (userInfo) => {
    try {
      const response = await Rest.post(ApiGatewayUrl + "/superadmin", userInfo.data);
      return response.data;
    }
    catch (ex) {
      ErrorException(ex.response);
    }
  }
)
export const disableUser = createAsyncThunk(
  "superAdmin/disableUser",
  async (userId) => {
    try {
      const respond = await Rest.put(ApiGatewayUrl + "/superadmin/disable/" + userId)
      return respond.data;
    }
    catch (ex) {
      ErrorException(ex.response);
    }
  }
)

export const enableUser = createAsyncThunk(
  "superAdmin/enableUser",
  async (userId) => {
    try {
      const respond = await Rest.put(ApiGatewayUrl + "/superadmin/enable/" + userId)
      return respond.data;
    }
    catch (ex) {
      ErrorException(ex.response);
    }
  }
)

export const deleteUsers = createAsyncThunk(
  "superAdmin/deleteUsers",
  async (id) => {
    try {
      const respond = await Rest.delete(ApiGatewayUrl + "/superadmin/" + id)
      return respond.data;
    }
    catch (ex) {
      ErrorException(ex.response);
    }
  }
)

export const superAdminSlice = createSlice({
  name: "superAdmin",
  initialState: {
    users: [],
    user: {},
    superAdminList: [],
    isLoading: false,
    userId: 0,
    errorMsg: "",
    total: 0,
    filterSuperAdmin: "",
    isCreated: false,
    changed: false,
  },
  reducers: {
    filterSuperAdmin(state, action) {
      state.filterSuperAdmin = action.payload;
    },
    saveChangedState: (state, action) => {
      state.changed = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(filterSuperAdmins.fulfilled, (state, action) => {
        return {
          ...state,
          total: action.payload.total,
          superAdminList: action.payload.superAdminList,
          isLoading: false
        }
      })
      .addCase(createUsers.fulfilled, (state) => {
        return { ...state, isLoading: false }
      })
      //handle pending actions.
      .addMatcher((action) => isReduxThunkPendingAction(SLICE_NAME, action.type), (state) => {
        return { ...state, isLoading: true, errorMessage: "" };
      })

      //handle rejected actions.   
      .addMatcher((action) => isReduxThunkRejectedAction(SLICE_NAME, action.type), (state, action) => {
        if (action.error && action.error.message === "Aborted") {
          return {
            ...state,
            isLoading: false,
            statusType: "",
            actionType: action.type?.split("/")[1],
            errorMessage: "",
          };
        } else {
          return {
            ...state,
            isLoading: false,
            actionType: action.type?.split("/")[1],
            statusType: STATUS_TYPES.rejected,
            errorMessage: getReduxActionErrorMessage(action)
          };
        }
      })
  }
});

export const superAdminActions = superAdminSlice.actions;
export const superAdminState = (state) => state.superAdmin;
export default superAdminSlice.reducer;